import tw from 'twin.macro';

export const Wrapper = tw.div`
  w-full flex flex-col gap-6  items-start 
`;

export const SeeMore = tw.button`
  underline font-bold capitalize
`;
